import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { SubmitCompanyFormType, submitCompanySchema } from "@/pages/auth/validation-schema"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import Cookies from "js-cookie"
import { useMutation, useQuery } from "@tanstack/react-query"
import { completeRegistration, getCompaniesShortList, submitCompany } from "@/pages/auth/api"
import { Button, Input, Select } from "@/shared/components"
import { Notice } from "@/shared/utils/notice.tsx"

const FormPage = () => {
  const [openEnded, setOpenEnded] = useState<boolean>(false)
  const [inn, setInn] = useState("")
  const session_id = Cookies.get("session_id")
  const { control, handleSubmit, setValue, watch } = useForm<SubmitCompanyFormType>({
    resolver: zodResolver(submitCompanySchema),
    defaultValues: {
      session_id: session_id ?? ""
    }
  })

  const { data, isLoading } = useQuery({
    queryKey: ["companies", inn],
    queryFn: () => getCompaniesShortList({ search: inn }),
    enabled: !!inn
  })

  const options = data?.results.map(item => ({
    value: item.id,
    label: item.name
  }))

  const findedValue = data?.results.find(s => s.inn === inn)

  useEffect(() => {
    if (findedValue?.id) {
      setValue("company_id", findedValue.id)
    }
  }, [findedValue])

  const completeReg = useMutation({
    mutationFn: completeRegistration
  })

  const create = useMutation({
    mutationFn: submitCompany,
    onSuccess: () => {
      Notice.success("Sizning so`rovingiz yuborildi", 300)
      setOpenEnded(true)
      completeReg.mutate({ session_id: session_id! })
      Cookies.remove("session_id")
    },
    onError: (error: string) => {
      Notice.error(error, 300)
    }
  })

  const onSubmit = (form: SubmitCompanyFormType) => {
    create.mutate({
      company_id: form.company_id,
      session_id: session_id!
    })
  }

  return (
    <>
      {openEnded ? (
        <div className={"text-center font-medium"}>Suravingiz yuborildi , Iltimos biroz kuting</div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-6">
            <div className="grid grid-cols-2 gap-4">
              <label>
                <span>ИНН</span>
                <Input maxLength={9} debounceDelay={500} onChange={e => setInn(e.target.value)} placeholder="Введите ИНН компании" />
              </label>

              <label>
                <span>Название</span>
                <Select.Form
                  control={control}
                  name="company_id"
                  disabled={!inn}
                  options={options || []}
                  onSelect={option => setValue("company_id", option?.value as any)}
                  loading={isLoading}
                />
              </label>
            </div>

            <Button type="submit">Отправить запрос</Button>
          </div>
        </form>
      )}
    </>
  )
}

export default FormPage
